import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const TransplantHallsActive: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <Toggle
      label={t('settings.shell.change.active.title')}
      value={settings.hostGroupSwitchPausable}
      onChange={(value: string) => {
        setSetting({
          alias: ESettingsAliases.SHELL_HOST_GROUP_SWITCH_PAUSABLE,
          value: value ? '1' : '0',
        });
      }}
      variant="secondary"
      emptyBg
    />
  );
};
